import { CustomEmoji } from "../api";

export const processContent = (content: string, emojis: CustomEmoji[]) => {
    for (const emoji of emojis) {
        content = content.replace(
            new RegExp(`:${emoji.shortcode}:`, "g"),
            `<img src="${emoji.static_url}" alt=":${emoji.shortcode}:" class="custom-emoji" />`
        );
    }
    return content;
};